import { render, staticRenderFns } from "./fornitori.vue?vue&type=template&id=22652b28&"
import script from "./fornitori.vue.ts?vue&type=script&lang=ts&"
export * from "./fornitori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports